<div class="{{localService.selectedLanguageCode}}" *ngIf="items">
  <div [ngClass]="isBoxRequired ? 'box' : 'no-box'" *ngIf="IsNumber">
    <div class="row" *ngIf="businessTaxCategories && businessTaxCategories.length > 0">
      <div class="col-12">
        <div style="display: flex;">
          <div style="width: calc(100% - 100px);">
            <ngx-select [items]="businessTaxCategories" [optionValueField]="'key'" [optionTextField]="'v1'"
              [(ngModel)]="selectedBusinessTaxCategory" [noAutoComplete]="true"
              (select)="onSelectBusinessTax()"></ngx-select>
          </div>
          <div style="width: 100px;">
            &nbsp;
            <button class="button_icon button_icon_color icon_adjust" [disabled]="isAdd || isEdit"
              title="{{localService.languageContent.seller.rename}}" (click)="onAction(1)">edit</button>
            &nbsp;
            <button class="button_icon button_icon_color icon_adjust" [disabled]="isAdd || isEdit"
              title="{{localService.languageContent.seller.add_business_tax}}" (click)="onAction(2)">add</button>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="isAdd || isEdit">
      <div class="col-1">
        <button class="button_icon button_icon_color icon_adjust" title="{{localService.languageContent.seller.cancel}}"
          (click)="onAction(3)">cancel</button>
      </div>
      <div class="col-10">
        <input autocomplete="off" type="text" [(ngModel)]="taxName"
          title="{{localService.languageContent.seller.title}}"
          placeholder="{{localService.languageContent.seller.tax_name}}" id="{{elementIds.tax_name}}" />
      </div>
      <div class="col-1">
        <button class="button_icon button_icon_color icon_adjust" [disabled]="!taxName || taxName.trim() == ''"
          title="{{localService.languageContent.seller.save}}" (click)="onAction(4)">save</button>
      </div>
    </div>
    <div class="row">
      <div [ngClass]="'col-md-'+columnSlot" class="no-css-row" *ngFor="let item of items;index as i">
        <div class="row styled_row">
          <div class="col-12">
            <div style="display: flex;">
              <div style="flex:1">
                <app-label [Text]="item.v1"></app-label>
              </div>
              <div style="flex:1">
                <input autocomplete="off" id="spp_line_{{i}}" type="number" class="number"
                  (keypress)="localService.isNumberOnly($event,numericConfig)" (blur)="onValueUpdate()"
                  [ngClass]="item.v3 != null && item.v3 != '' ? 'en' : localService.getLanguageCode(item.v2)"
                  [(ngModel)]="item.v3" title="{{item.v1}}" placeholder="{{item.v1}}" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [ngClass]="isBoxRequired ? 'box' : 'no-box'" *ngIf="!IsNumber">
    <div class="row styled_row" *ngFor="let item of items">
      <div class="col-12">
        <div style="display: flex;">
          <div style="flex:1">
            <app-label [Text]="item.v1"></app-label>
          </div>
          <div style="flex:1">
            <input autocomplete="off" type="text" (blur)="onValueUpdate()"
              [ngClass]="item.v3 != null && item.v3 != '' ? 'en' : localService.getLanguageCode(item.v2)"
              [(ngModel)]="item.v3" title="{{item.v1}}" placeholder="{{item.v1}}" />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>